export type JsonValue = null | string | number | boolean | { [x: string]: JsonValue } | Array<JsonValue>

export default (function safeJsonParse<T = JsonValue>(json: string | null | undefined, defaultValue: T | null = null) {
    if (json === null || json === undefined) return defaultValue
    try {
        return JSON.parse(json) ?? defaultValue
    } catch (error) {
        return defaultValue
    }
} as (<T extends JsonValue>(json: string | null) => T | null) &
    (<T extends JsonValue>(json: string | null, defaultValue: T) => T))
